import React, { useEffect } from "react";
import { FaCar, FaTruck, FaTools, FaAmbulance } from "react-icons/fa";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

// Data for the services
const servicesData = [
  {
    title: "Quality Used Vehicle Spares",
    description:
      "Our used spare stock comes from accident-damaged vehicles, auctions and insurance salvage contractors, panel beaters, and private individuals.",
    icon: <FaCar className="text-blue-500 text-4xl mb-2" />,
    image: "/service1.jpg",
  },
  {
    title: "Nationwide Deliveries",
    description:
      "We deliver daily in & around Nelson Mandela Bay. Regular clients get FREE deliveries. Enjoy nationwide overnight delivery via courier. Contact us for rates.",
    icon: <FaTruck className="text-green-500 text-4xl mb-2" />,
    image: "/service2.jpg",
  },
  {
    title: "Towing & Recovery",
    description:
      "We do Towing & Recovery 24/7 and we have Roadside Assistance on standby 24/7, contact us for the Best, Reliable and Fastest service.",
    icon: <FaAmbulance className="text-red-500 text-4xl mb-2" />,
    image: "/service3.jpg",
  },
  {
    title: "Vehicle Purchasing",
    description:
      "We buy & sell Cars, Trucks, Trailers & Piggybacks, including those with: Mechanical Issues, Running Or Not, Slight Accident Damage.",
    icon: <FaTools className="text-yellow-500 text-4xl mb-2" />,
    image: "/service4.jpg",
  },
];

// Component for individual service cards
const ServiceCard = ({ service }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.15, // Trigger animation when 15% of the component is visible
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        visible: { opacity: 1, y: 0, scale: 1 },
        hidden: { opacity: 0, y: 50, scale: 0.95 },
      }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="bg-white p-4 md:p-6 rounded-lg shadow-md flex flex-col items-center text-center relative overflow-hidden group transform transition-all duration-500 hover:shadow-lg"
    >
      <div className="w-full h-40 md:h-56 mb-4 overflow-hidden rounded-lg relative">
        <img
          src={service.image}
          alt={service.title}
          loading="lazy"
          className="w-full h-full object-cover rounded-lg transform transition-transform duration-300 ease-in-out group-hover:scale-105"
        />
      </div>
      <div>{service.icon}</div>
      <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2">
        {service.title}
      </h3>
      <p className="text-gray-600 text-sm md:text-base">
        {service.description}
      </p>
    </motion.div>
  );
};

// Services section component
const Services = () => {
  return (
    <section
      className="py-10 md:py-16 bg-cover bg-center text-white relative"
      style={{
        backgroundImage: "url('/bg.jpg')",
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      {/* Overlay for better contrast */}
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 md:mb-12 relative z-10">
        Our Services
      </h2>
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8 relative z-10 px-4">
        {servicesData.map((service, index) => (
          <ServiceCard key={index} service={service} />
        ))}
      </div>
    </section>
  );
};

export default Services;
